import { gql } from '@apollo/client';

const UPDATE_INSTALLER = gql`
    mutation UpdateInstaller($input: UpdateInstaller!) {
        updateInstaller(input: $input) {
            data {
                first_name
                last_name
            }
            message
            success
        }
    }
`;

const UPDATE_ADMIN = gql`
    mutation UpdateAdmin($input: UpdateAdmin!) {
        updateAdmin(input: $input) {
            data {
                first_name
                last_name
            }
            message
            success
        }
    }
`;
const UPDATE_INSTALLATION = gql`
    mutation UpdateInstallation($input: UpdateInstallation!) {
        updateInstallation(input: $input) {
            data {
                id
                installer_user_id
                installer_name
                customer_id
                customer_name
                address_id
                machine_serial_id
                installation_date
                status
                installation_started_at
                installation_ended_at
                agency_id
                createdAt
                updatedAt
            }
            message
            success
        }
    }
`;
const ADD_INSTALLATION = gql`
    mutation AddInstallation($input: AddInstallation!) {
        addInstallation(input: $input) {
            data {
                id
                installer_user_id
                installer_name
                customer_id
                customer_name
                address_id
                machine_serial_id
                installation_date
                status
                installation_started_at
                installation_ended_at
                agency_id
                createdAt
                updatedAt
            }
            message
            success
        }
    }
`;
const ADD_INSTALLER = gql`
    mutation AddInstaller($input: AddInstaller!) {
        addInstaller(input: $input) {
            data {
                id
                cognito_id
                first_name
                last_name
                username
                email
                phone_number
                application_type
                status
                last_logged_at
                profile_image
                role_id
                createdAt
                updatedAt
                user_addresses {
                    id
                    user_id
                    street
                    city
                    state
                    zip_code
                    country
                    address_type
                    createdAt
                    updatedAt
                }
                installer_users {
                    id
                    user_id
                    agency_id
                    license_number
                    avg_installation_time
                    createdAt
                    updatedAt
                }
            }
            message
            success
        }
    }
`;

const CREATE_ADMIN = gql`
    mutation AddAdmin($input: AddAdmin!) {
        addAdmin(input: $input) {
            data {
                id
                username
                email
                last_logged_at
                cognito_id
                first_name
                last_name
                status
            }
            message
            success
        }
    }
`;
const UPDATE_CUSTOMER = gql`
    mutation UpdateCustomer($input: UpdateCustomer!) {
        updateCustomer(input: $input) {
            data {
                id
                cognito_id
                first_name
                last_name
                username
                email
                phone_number
                application_type
                status
                last_logged_at
                profile_image
                role_id
                createdAt
                updatedAt
                user_addresses {
                    id
                    user_id
                    street
                    city
                    state
                    zip_code
                    country
                    address_type
                    createdAt
                    updatedAt
                }
                device_arn
                installer_users {
                    id
                    user_id
                    agency_id
                    license_number
                    avg_installation_time
                    createdAt
                    updatedAt
                }
            }
            message
            success
        }
    }
`;

export {
    UPDATE_INSTALLER,
    UPDATE_INSTALLATION,
    ADD_INSTALLATION,
    UPDATE_ADMIN,
    CREATE_ADMIN,
    ADD_INSTALLER,
    UPDATE_CUSTOMER,
};
